module.exports = __webpack_public_path__ + "static/media/paperclip~GNcKVwLM.4110e480.svg";